import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useSearchInputStyles = makeStyles(({ spacing, palette, shadows }) => {
  const sharedStyle = {
    backgroundColor: palette.common.white,
    color: palette.common.black,
  };
  return createStyles({
    input: {
      paddingTop: spacing(2),
      paddingLeft: spacing(2),
    },
    root: {
      ...sharedStyle,
      '&:hover': {
        ...sharedStyle,
      },
    },
    textField: {
      ...sharedStyle,
      borderRadius: spacing(),
      width: '100%',
      boxShadow: shadows[3],
      '& .Mui-focused': {
        ...sharedStyle,
      },
    },
  });
});

export default useSearchInputStyles;
